import { useEffect, useRef } from 'react'

export const parseURLParams = (keys: { key: string; parsedKey?: string }[]): { [key: string]: string } => {
  // search isn't always reliable ex: https://powcloud.test/dash#/login?reset_password_token=abcd
  const [domain, urlParams] = window.location.href.split('?')
  const params = new URLSearchParams(urlParams)
  const parsedParams = {}

  keys.forEach((k) => {
    if (params.get(k.key)) parsedParams[k.parsedKey || k.key] = params.get(k.key)
  })

  return parsedParams
}

export const capitalizeStr = (word: string, lowerRest = true): string => {
  if (word.length == 0) return word

  const first = word[0]
  const rest = word.slice(1)

  return first.toUpperCase() + (lowerRest ? rest.toLowerCase() : rest)
}

export const debounce = (callback: (...args: any[]) => void, wait: number): ((...args: any[]) => void) => {
  let timeout: NodeJS.Timeout

  return (...args: any[]) => {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => callback(...args), wait)
  }
}

// https://stackoverflow.com/questions/53446020/how-to-compare-oldvalues-and-newvalues-on-react-hooks-useeffect
export function usePrevious(value: any): any {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function nestedObjectTo1DArrayOfKVPairs(obj, props = []): { keys: string[]; value: string }[] {
  let result: { keys: string[]; value: string }[] = []
  for (const prop in obj) {
    const value = obj[prop]
    const propPath: string[] = [...props, prop]
    if (typeof value === 'object') {
      result = [...result, ...nestedObjectTo1DArrayOfKVPairs(value, propPath)] // <- recursive call
    } else {
      result.push({ keys: propPath, value })
    }
  }
  return result
}

export function flattenNestedObject(data: { [key: string]: any }): { [key: string]: string } {
  const _1DArray = nestedObjectTo1DArrayOfKVPairs(data)

  const rtnVal: { [key: string]: string } = {}

  _1DArray.forEach((data) => {
    let key = ''

    if (data.keys.length == 1) key = data.keys[0]
    else {
      data.keys.forEach((nestedKey, i) => {
        if (i == 0) key += nestedKey
        else key += `[${nestedKey}]`
      })
    }

    rtnVal[key] = data.value
  })

  return rtnVal
}
